import {
  faDownload,
  faEllipsisH,
  faEye,
  faBrakeWarning,
} from '@fortawesome/pro-regular-svg-icons'
import { ActionIcon, Flex, Menu } from '@mantine/core'
import Link from 'next/link'

import { useTranslation } from '@flecto/translations'
import { type CoreInsurance } from '@flecto/types'
import { Icon, useModal } from '@flecto/ui'

export type CellActionsProps = {
  insurance?: CoreInsurance
}

export function CellActions({ insurance }: CellActionsProps) {
  const { t } = useTranslation('saas', { keyPrefix: 'booking_insurances' })
  const { closeModal } = useModal()

  return (
    <Flex align='center' gap='sm' justify='flex-end'>
      <Menu position='bottom-end' zIndex={9999}>
        <Menu.Target>
          <ActionIcon
            size='sm'
            variant='default'
            c='gray.7'
            onClick={(e) => e.stopPropagation()}
          >
            <Icon icon={faEllipsisH} size='sm' />
          </ActionIcon>
        </Menu.Target>
        <Menu.Dropdown>
          <Menu.Item
            leftSection={<Icon icon={faEye} size='sm' />}
            component={Link}
            href={`/insurances/${insurance?.internal_id}`}
            onClick={closeModal}
          >
            {t('label_see_details')}
          </Menu.Item>
          <Menu.Item
            leftSection={<Icon icon={faDownload} size='sm' />}
            component='a'
            href={insurance?.terms_url}
            target='_blank'
          >
            {t('label_see_conditions')}
          </Menu.Item>
          <Menu.Item
            leftSection={<Icon icon={faBrakeWarning} size='sm' />}
            component='a'
            target='_blank'
            href={insurance?.claim_url}
          >
            {t('label_claims')}
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
    </Flex>
  )
}
